// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AntDesignOutlinedSvg from "@fishx/icons-svg/es/asn/AntDesignOutlined";
import FishxIcon from '../components/FishxIcon';

var AntDesignOutlined = function AntDesignOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AntDesignOutlinedSvg
  }));
};

AntDesignOutlined.displayName = 'AntDesignOutlined';
export default React.forwardRef(AntDesignOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AntDesignOutlined.js
// module id = 1987
// module chunks = 0